(function ($) {
  "use strict";
  //clear button control
  var $inputBox = $(".search__input");

  const searchAutocomplete = {
    sel: {
      search: "#search__query-autocomplete-animal",
      searchMenu: ".search__input--menu",
      searchHint: ".search__input--hint",
      main: ".main",
      searchIcon: ".search__submit--icon",
      searchCancel: ".search__submit--cancel",
      form: ".search__form-wrap > form",
    },
    vars: {
      classNames: "search__input",
      url:
        $("#search__query-autocomplete-animal").attr("data-typeahead") +
        "?partial_query=",
      wideBreakpoint: 1024,
      viewAll: "View all results",
      keys: {
        ENTER: 13,
      },
    },
    init() {
      this.initTypehead();
      this.setAutosuggestionWidth();
      this.sendQuery();
    },
    initTypehead() {
      const self = this;
      $(this.sel.search).typeahead(
        {
          name: "animal-search",
          hint: true,
          highlight: true,
          minLength: 2,
          classNames: {
            input: self.vars.classNames + "--input",
            hint: self.vars.classNames + "--hint",
            menu: self.vars.classNames + "--menu",
            dataset: self.vars.classNames + "--dataset",
            suggestion: self.vars.classNames + "--suggestion",
            empty: self.vars.classNames + "--empty",
            open: self.vars.classNames + "--open",
            cursor: self.vars.classNames + "--cursor",
            highlight: self.vars.classNames + "--highlight",
            selectable: self.vars.classNames + "--selectable",
          },
        },
        {
          name: "data",
          async: true,
          limit: 10,
          source: function (query, sync, async) {
            self.fetchData(query, async);
          },
          display: function (item) {
            return item.category;
          },
          templates: {
            suggestion: function (data) {
              return `<div>${data.category}<div class="related-terms">${data.related}</div></div>`;
            },
          },
        }
      );
    },
    fetchData(query, cb) {
      const self = this,
        url = this.vars.url + encodeURIComponent(query),
        querySting = query.toLowerCase();

      fetch(url)
        .then((res) => res.json())
        .then((res) => {
          for (var i = res.length - 1; i >= 0; i--) {
            var resCat = res[i].category.toLowerCase(),
              resRelated = res[i].related.toLowerCase();

            if (
              resCat.indexOf(querySting) === -1 &&
              resRelated.indexOf(querySting) === -1
            ) {
              res.splice(i, 1);
            }
          }
          cb(res);
        });
    },
    setAutosuggestionWidth() {
      if (window.innerWidth < this.vars.wideBreakpoint) {
        $(this.sel.searchMenu).css({
          width: $(this.sel.main).width() + "px",
          left: "-10px",
        });
      }
    },
    sendQuery() {
      const self = this;
      $(this.sel.search).bind("typeahead:select", function (e, suggestion) {
        $(this).typeahead("close");
        $(this).val(suggestion.category);
        window.location = suggestion.url;
      });

      // Add name query to input field for accessibility
      $(".search__input--hint").attr({
        name: "animal-hint",
        title: "Animal Hint",
      });
    },
  };

  searchAutocomplete.init();

  // Attach event listener
  var searchInput = document.getElementById(
    "search__query-autocomplete-animal"
  );
  if (searchInput) {
    searchInput.addEventListener("input", categoryFilter);
  }

  function categoryFilter() {
    // Add class to nodes that match
    var animalCatEl = document.getElementsByClassName("animal-category"),
      noResults = document.getElementsByClassName("iwt-no-results"),
      currentQuery = this.value.toLowerCase(),
      resultcount = 0;

    // Loop through categories
    for (var i = 0; i < animalCatEl.length; i++) {
      var animalQuery = animalCatEl[i]
          .getAttribute("data-category")
          .toLowerCase(),
        animalRelated = animalCatEl[i]
          .getAttribute("data-related")
          .toLowerCase();

      // Match query with category and related terms
      if (
        animalQuery.indexOf(currentQuery) !== -1 ||
        animalRelated.indexOf(currentQuery) !== -1
      ) {
        animalCatEl[i].parentNode.classList.remove("hide-animal-cat");
        resultcount++;
      } else {
        animalCatEl[i].parentNode.classList.add("hide-animal-cat");
      }
    }

    if (resultcount == 0) {
      for (var i = 0; i < noResults.length; i++) {
        noResults[i].classList.add("show-el");
      }
      resultcount = 0;
    } else {
      for (var i = 0; i < noResults.length; i++) {
        noResults[i].classList.remove("show-el");
      }
      resultcount = 0;
    }
  }

  $(".iwt-search-form").on("submit", function (e) {
    e.preventDefault();
    $(this.sel.search).typeahead("close");
  });
})(jQuery);
